import DefaultRegion from './DefaultRegion';
import ContrastRegion from './ContrastRegion';
import HighlightRegion from './HighlightRegion';
export const regions = [DefaultRegion, ContrastRegion, HighlightRegion];